// Firebase config — environment-driven with DEV fallbacks.
//
// The web builds are environment-agnostic: `npm run build:dev` injects the
// dev (fodyfee-affcc) values from .env.dev, `npm run build:prod` injects the
// prod (fodyfee-prod) values from .env.prod (see package.json scripts).
// When no env vars are present (e.g. the local dev server without a .env
// file), the hardcoded DEV values below keep everything working exactly as
// before — zero risk of breaking the current dev workflow.
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyAnBY2pCJYI8n_6BmlVZIGsrCAWGQ3c2W0',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'fodyfee-affcc.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'fodyfee-affcc',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'fodyfee-affcc.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '659841746443',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:659841746443:web:f094d2c54f64f8f01f290e',
};

export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN || 'pk.eyJ1IjoiZm9keWZlZSIsImEiOiJjbW9oajFwM2wwMDBnMnJxNDhuMTJzMGJmIn0.6uGoChaqV6fu36VllxEN5g';

export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_51TQwB8FdDW3Pxjul07cr2oaBNRzS6I7LkJOkYvFD5TuCzY49R8tZGu12vXRCS5uLwmE7P2AD3V5FzbRey9G76Dtu0080iR3Exx';
